import { reduxForm } from 'redux-form/immutable'
import { connect } from 'react-redux'

import UserAvatarForm from './UserAvatarForm'
import { saveProfile } from 'store/entities/identity/actions'
import { getIdentityUserData } from 'store/entities/identity/selectors'
import { PROFILE_AVATAR_FORM_NAME } from 'app/constants/profile'

const mapStateToProps = state => ({
  initialValues: getIdentityUserData(state),
})

const mapDispatchToProps = {
  onSubmit: saveProfile,
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: PROFILE_AVATAR_FORM_NAME,
    enableReinitialize: true,
  })(UserAvatarForm)
)
